import type { FC } from "react";
import React from "react";
import { Virtuoso } from "react-virtuoso";

import { getUserPresentableMessage } from "@core/foundation/error";

import { EmptyView, ErrorView } from "@react/foundation/placeholder";
import { useInfiniteQuery } from "@react/foundation/query";

import { useQueries } from "../../../shared/hooks/useQueries.ts";

import { GenerationCard } from "./GenerationCard.tsx";
import { GenerationCardSkeleton } from "./GenerationCardSkeleton.tsx";

export const GenerationList: FC = () => {
  const { getGenerationsQueryOptions } = useQueries();
  const generationsQueryOptions = getGenerationsQueryOptions({ order: "desc" });
  const generations = useInfiniteQuery(generationsQueryOptions.infinite);

  if (generations.status === "pending") {
    return (
      <>
        <GenerationCardSkeleton className="mb-2" />
        <GenerationCardSkeleton className="mb-2" />
        <GenerationCardSkeleton className="mb-2" />
      </>
    );
  }

  if (generations.status === "error") {
    return (
      <ErrorView
        description={getUserPresentableMessage(
          generations.error,
          "Failed to load generations.",
        )}
      />
    );
  }

  if (generations.items.length === 0) {
    return (
      <EmptyView
        description="Images your agent generates will appear here."
        title="No generations yet"
      />
    );
  }

  return (
    <Virtuoso
      computeItemKey={(_, { generation }) => generation.id}
      data={generations.items}
      endReached={generations.loadNextPage}
      itemContent={(_, { generation, images }) => (
        <GenerationCard
          className="mb-2"
          generation={generation}
          images={images}
        />
      )}
      useWindowScroll
    />
  );
};
